/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Services;
    (function (Services) {
        var ApplicationService = /** @class */ (function () {
            function ApplicationService($cookies, $filter, $q, $routeParams, applicationApiService, authenticationService, localStorageService, locationService, metaService, ssoService, isWpReport, metaStorageKey, reportStorageKey, appRoles, activeReport, reportParameters) {
                this.$cookies = $cookies;
                this.$filter = $filter;
                this.$q = $q;
                this.$routeParams = $routeParams;
                this.applicationApiService = applicationApiService;
                this.authenticationService = authenticationService;
                this.localStorageService = localStorageService;
                this.locationService = locationService;
                this.metaService = metaService;
                this.ssoService = ssoService;
                this.isWpReport = isWpReport;
                this.metaStorageKey = metaStorageKey;
                this.reportStorageKey = reportStorageKey;
                this.appRoles = appRoles;
                this.activeReport = activeReport;
                this.reportParameters = reportParameters;
                this.authData = this.authenticationService.authorizationData;
                this.authDataCookieName = 'authorizationData';
                this.organizationList = [];
                this.isWpReport = this.authenticationService.authorizationData.LoginSystem !== 'SSO';
                this.metaStorageKey = 'metaValues';
                this.reportStorageKey = 'activeReport';
                this.appRoles = this.authData.ApplicationRoles;
            }
            ApplicationService.prototype.initActiveReport = function () {
                var _this = this;
                this.ssoService.loadUsersOrganizationsList().then(function (organizationList) {
                    _this.organizationList = organizationList;
                    _this.organizationCacheKey = _this.locationService.getOrganizationCacheKey(_this.organizationList, true, true);
                    _this.getActiveReport().then(function (activeReport) {
                        _this.activeReport = activeReport;
                    });
                });
            };
            ApplicationService.prototype.getActiveReport = function () {
                var _this = this;
                return this.$q(function (resolve) {
                    _this.localStorageService.getItem(_this.reportStorageKey).then(function (activeReport) {
                        if (!ap.Utilities.isNullOrUndefined(activeReport)) {
                            _this.setActiveReport(activeReport).then(function (updatedActiveReport) {
                                _this.activeReport = updatedActiveReport;
                                resolve(_this.activeReport);
                            });
                        }
                        else {
                            var rp = _this.$routeParams;
                            if (!ap.Utilities.isNullOrUndefined(rp) &&
                                !ap.Utilities.isNullOrUndefined(rp.organizationCacheKey) &&
                                rp.organizationCacheKey !== ':organizationKey?') {
                                _this.locationService.redirect(ap.Constants.routes.reporting, null, rp.organizationCacheKey);
                            }
                            else {
                                _this.locationService.redirect(ap.Constants.routes.reporting, null, null);
                            }
                        }
                    });
                });
            };
            ApplicationService.prototype.getOrganizationType = function () {
                var _this = this;
                return this.$q(function (resolve) {
                    var guid = _this.getDefaultOrg();
                    _this.ssoService.loadUsersOrganizationsList().then(function (organizationList) {
                        resolve(organizationList[guid].type);
                    });
                });
            };
            ApplicationService.prototype.getParameterValue = function (reportDataTypeId) {
                var thisParam = this.activeReport.parameters.find(function (x) { return x.reportDataTypeId === reportDataTypeId; }); // tslint:disable-line
                return thisParam.value;
            };
            ApplicationService.prototype.setActiveReport = function (newActiveReport) {
                var _this = this;
                return this.$q(function (resolve) {
                    if (!ap.Utilities.isNullOrUndefined(newActiveReport)) {
                        // Before we update the active report, let's check cached meta values
                        _this.metaService.checkMetaValues(newActiveReport).then(function (updatedActiveReport) {
                            _this.activeReport = angular.copy(updatedActiveReport);
                            _this.labelOptionDisplay().then(function () {
                                _this.metaService.updateMetaValues(_this.activeReport.parameters);
                                _this.localStorageService.setItem(_this.reportStorageKey, _this.activeReport);
                                resolve(_this.activeReport);
                            });
                        });
                    }
                    else {
                        // Use an "else" so that we don't accidentally send the original back while waiting on the above promises
                        resolve(newActiveReport);
                    }
                });
            };
            ApplicationService.prototype.getDealerKey = function () {
                return this.getParameterValue(MetaParameters.OrganizationUnit) || Guid.empty;
            };
            ApplicationService.prototype.getDefaultOrg = function () {
                var orgKey = undefined;
                if (!ap.Utilities.isNullOrUndefined(this.$routeParams.organizationCacheKey)) {
                    orgKey = this.$routeParams.organizationCacheKey.toLowerCase();
                }
                else {
                    var wpAuthData = this.authenticationService.authorizationData;
                    orgKey = wpAuthData.OrganizationUnitCacheKey;
                }
                return orgKey;
            };
            ApplicationService.prototype.resetReportParams = function () {
                this.reportParameters = undefined;
            };
            ApplicationService.prototype.getReports = function () {
                var _this = this;
                var filterReports = function () {
                    return _this.$q(function (resolve) {
                        _this.applicationApiService.getAssignedReports().then(function (reportsList) {
                            _this.metaService.processReportsAndMeta(reportsList).then(function (sortedReports) {
                                _this.reportsList = sortedReports;
                                resolve(sortedReports);
                            });
                        });
                    });
                };
                return this.$q(function (resolve) {
                    if (!ap.Utilities.isNullOrUndefined(_this.$cookies.getObject(_this.authDataCookieName))) {
                        _this.ssoService.renewAccessToken().then(function () {
                            resolve(filterReports());
                        });
                    }
                    else {
                        resolve(filterReports());
                    }
                });
            };
            ApplicationService.prototype.labelOptionDisplay = function () {
                var _this = this;
                return this.$q(function (resolve) {
                    if (!_this.isWpReport && !ap.Utilities.isNullOrUndefined(_this.activeReport)) {
                        angular.forEach(_this.activeReport.parameters, function (param) {
                            switch (param.type) {
                                case 'date':
                                    if (param.value === ap.Constants.metaValues.date.custom.value) {
                                        // If the user is using custom date ranges, set some default params and then attempt
                                        // to get any existing params from other reports
                                        var endDate = new Date(), startDate = new Date();
                                        startDate.setMonth(startDate.getMonth() - 1);
                                        if (!ap.Utilities.isNullOrUndefined(param.startDate) &&
                                            !ap.Utilities.isNullOrUndefined(param.endDate)) {
                                            startDate = param.startDate;
                                            endDate = param.endDate;
                                        }
                                        param.startDate = _this.$filter('date')(startDate, 'yyyy-MM-dd');
                                        param.endDate = _this.$filter('date')(endDate, 'yyyy-MM-dd');
                                        param.displayLabel = _this.$filter('date')(startDate, 'mediumDate') + " to " + _this.$filter('date')(endDate, 'mediumDate');
                                    }
                                    else {
                                        angular.forEach(param.options, function (option) {
                                            if (option.value === param.value) {
                                                param.displayLabel = option.label;
                                            }
                                        });
                                    }
                                    break;
                                case 'dateStartEndMonth':
                                    var startOption = param.options.find(function (x) { return x.value === param.value[0]; }), // tslint:disable-line
                                    endOption = param.options.find(function (x) { return x.value === param.value[1]; }); // tslint:disable-line
                                    param.displayLabel = startOption.label + " to " + endOption.label;
                                    break;
                                case 'multiCheckbox':
                                    param.value = [];
                                    param.displayLabel = [];
                                    var allOption = param.options.find(function (x) { return x.value === ap.Constants.metaValues.multiCheckbox.all.value; }), allSelected = allOption.isSelected;
                                    if (allSelected) {
                                        param.value = [allOption.value];
                                        param.displayLabel = [allOption.label];
                                    }
                                    angular.forEach(param.options, function (option) {
                                        if (allSelected) {
                                            option.isSelected = true;
                                        }
                                        else {
                                            if (option.isSelected) {
                                                option.isSelected = true;
                                                param.displayLabel.push(option.label);
                                                param.value.push(option.value);
                                            }
                                        }
                                    });
                                    // If we found no valid values, push default
                                    if (param.displayLabel.length < 1) {
                                        var defaultOption = param.options.find(function (x) { return x.isDefault; });
                                        param.displayLabel.push(defaultOption.label);
                                        param.value.push(defaultOption.value);
                                    }
                                    break;
                                default:
                                    angular.forEach(param.options, function (option) {
                                        if (option.value === param.value) {
                                            param.displayLabel = option.label;
                                        }
                                    });
                                    break;
                            }
                            if (!ap.Utilities.isNullOrUndefined(param.displayLabel)) {
                                param.displayLabelType = typeof param.displayLabel;
                            }
                        });
                        resolve();
                    }
                    else {
                        resolve();
                    }
                });
            };
            ApplicationService.prototype.secureReports = function () {
                var _this = this;
                var orgType;
                var filterReports = function () {
                    _this.appRoles = _this.authData.ApplicationRoles;
                    //RSC-1512 Wp auth refresh doesn't include appRoles
                    if (_this.isWpReport && _this.appRoles.indexOf(AutoPointRole.WelcomePointUser) < 0) {
                        _this.appRoles.push(AutoPointRole.WelcomePointUser);
                    }
                    var reportsListData = ap.Constants.reportsList, availableReports = [], enterpriseAdded = false;
                    angular.forEach(_this.appRoles, function (role) {
                        var roleReports = [];
                        // ER will be valid on Alphas and non-alphas moving forward, so just make sure we're not looking at a Location/Dealership
                        // If they're admin on SSO they should have ER but not Admin on WP, because we can't run ER on dealerships
                        if (!enterpriseAdded &&
                            (role === AutoPointRole.EnterpriseReportsUser ||
                                (role === AutoPointRole.Admin && !_this.isWpReport)) &&
                            orgType !== OrganizationUnitType.Location) {
                            roleReports = reportsListData.filter(function (x) { return x.active && x.productId === AutoPointRole.EnterpriseReportsUser; });
                            var enterpriseReports = {
                                associatedProduct: 'enterprise',
                                name: 'Enterprise Reports',
                                reports: roleReports
                            };
                            availableReports.push(enterpriseReports);
                            enterpriseAdded = true;
                        }
                        // WP doesn't register orgType apparently, but we need to keep the WelcomePointUser check on here or we get multiple copies of WP reports
                        if (role === AutoPointRole.WelcomePointUser &&
                            availableReports.filter(function (x) { return x.associatedProduct === 'welcomepoint'; }).length < 1 &&
                            (orgType === OrganizationUnitType.Location || _this.isWpReport)) {
                            roleReports = reportsListData.filter(function (x) { return x.active && x.productId === AutoPointRole.WelcomePointUser; });
                            var wpReports = {
                                associatedProduct: 'welcomepoint',
                                name: 'WelcomePoint Reports',
                                reports: roleReports
                            };
                            availableReports.push(wpReports);
                        }
                    });
                };
                return this.$q(function (resolve) {
                    // Org Type doesn't function with WP
                    if (_this.isWpReport) {
                        resolve(filterReports());
                    }
                    else {
                        _this.getOrganizationType().then(function (type) {
                            orgType = type;
                            _this.ssoService.renewAccessToken().then(function () {
                                resolve(filterReports());
                            });
                        });
                    }
                });
            };
            ApplicationService.prototype.updateReportRoute = function (reportName) {
                var _this = this;
                return this.$q(function (resolve) {
                    _this.getReports().then(function (reportsListData) {
                        angular.forEach(reportsListData, function (reportGroup) {
                            angular.forEach(reportGroup, function (report) {
                                if (report.ssrsName.toLowerCase() === reportName) {
                                    _this.metaService.checkMetaValues(report).then(function (updatedReport) {
                                        _this.setActiveReport(updatedReport).then(function () {
                                            resolve();
                                        });
                                    });
                                }
                            });
                        });
                    });
                });
            };
            ApplicationService.$inject = [
                '$cookies',
                '$filter',
                '$q',
                '$routeParams',
                'applicationApiService',
                'authenticationService',
                'localStorageService',
                'locationService',
                'metaService',
                'ssoService'
            ];
            return ApplicationService;
        }());
        Services.ApplicationService = ApplicationService;
        angular.module('app.Services').service('applicationService', ApplicationService);
    })(Services = app.Services || (app.Services = {}));
})(app || (app = {}));
